var scope_0 = require('/home/runner/work/a66-digital-pei-report/a66-digital-pei-report/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be24e1bb2b3d89243183e8ac7bd9e03c.js').default;
var scope_1 = require('/home/runner/work/a66-digital-pei-report/a66-digital-pei-report/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    